import { useId } from 'react';
import type { SVGProps } from 'react';

/**
 * Official what3words brand mark — three white slashes ("///") on a black rounded square.
 * Replaces the previous CSS text badge so the logo matches the supplied brand asset exactly.
 *
 * Size is controlled by the caller's className (e.g. `size-6`); the colour is the fixed brand
 * palette — black square via the `--w3w-brand` token, white slashes. The clip-path id is made
 * unique per instance with useId() so the rounded corners render correctly when several logos
 * appear on the same page (e.g. the POI panel's two what3words fields).
 */
export function What3WordsLogo(props: SVGProps<SVGSVGElement>) {
    const clipId = useId();
    return (
        <svg
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="what3words"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path d="M22.8006 0H0V22.8005H22.8006V0Z" fill="var(--w3w-brand)" />
                <path
                    d="M9.97397 16.3874C9.86113 16.3873 9.74993 16.3603 9.64951 16.3088C9.5491 16.2574 9.46234 16.1828 9.39636 16.0912C9.33037 15.9997 9.28705 15.8938 9.26995 15.7822C9.25286 15.6707 9.26247 15.5567 9.298 15.4496L12.1481 6.89925C12.2079 6.71997 12.3364 6.57178 12.5055 6.48729C12.6745 6.4028 12.8702 6.38892 13.0495 6.44871C13.2288 6.5085 13.377 6.63707 13.4615 6.80612C13.546 6.97517 13.5598 7.17086 13.5 7.35014L10.65 15.9004C10.6026 16.0423 10.5119 16.1656 10.3906 16.253C10.2692 16.3404 10.1235 16.3874 9.97397 16.3874Z"
                    fill="#ffffff"
                />
                <path
                    d="M5.70055 16.3877C5.5877 16.3875 5.47651 16.3606 5.37609 16.3091C5.27568 16.2576 5.18892 16.183 5.12293 16.0915C5.05695 15.9999 5.01362 15.8941 4.99652 15.7825C4.97942 15.671 4.98903 15.557 5.02455 15.4499L7.87462 6.89952C7.93477 6.72068 8.06338 6.57299 8.23226 6.48885C8.40115 6.4047 8.59651 6.39097 8.7755 6.45067C8.95449 6.51036 9.1025 6.6386 9.18707 6.80727C9.27164 6.97594 9.28586 7.17127 9.22662 7.35041L6.37652 15.9007C6.32919 16.0425 6.23844 16.1659 6.11712 16.2533C5.99581 16.3407 5.85007 16.3877 5.70055 16.3877Z"
                    fill="#ffffff"
                />
                <path
                    d="M14.2513 16.3877C14.1385 16.3875 14.0273 16.3606 13.9269 16.3091C13.8265 16.2576 13.7397 16.183 13.6737 16.0915C13.6077 15.9999 13.5644 15.8941 13.5473 15.7825C13.5302 15.671 13.5398 15.557 13.5753 15.4499L16.4254 6.89952C16.4855 6.72068 16.6142 6.57299 16.783 6.48885C16.9519 6.4047 17.1473 6.39097 17.3263 6.45067C17.5053 6.51036 17.6533 6.6386 17.7378 6.80727C17.8224 6.97594 17.8366 7.17127 17.7774 7.35041L14.9273 15.9007C14.88 16.0425 14.7892 16.1659 14.6679 16.2533C14.5466 16.3407 14.4009 16.3877 14.2513 16.3877Z"
                    fill="#ffffff"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="22.8006" height="22.8005" rx="4" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
